import { useQuery } from "@tanstack/react-query";

import { getPolicies } from "../../policies/services";

const usePolicies = (policesIdFilter?: number[]) => {
  const { data, isLoading } = useQuery(["policies"], getPolicies, {
    staleTime: 1000 * 60 * 60,
  });

  let policies = data;
  if (data && policesIdFilter) {
    policies = data.filter((policy) =>
      policesIdFilter.includes(policy.policyTypeId)
    );
  }

  return {
    policies,
    isLoading,
  };
};

export default usePolicies;
